import { render, staticRenderFns } from "./FailureIcon.vue?vue&type=template&id=4357605c&scoped=true"
import script from "./FailureIcon.vue?vue&type=script&lang=js"
export * from "./FailureIcon.vue?vue&type=script&lang=js"
import style0 from "./FailureIcon.vue?vue&type=style&index=0&id=4357605c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4357605c",
  null
  
)

export default component.exports